import * as React from "react";
import { ButtonVNext } from "designer/ui/smart/button-vnext/button-vnext";
import { SectionHeaderStyle } from "./section-header-style";

interface Props {
    readonly name: React.ReactNode;
    readonly bold?: boolean;
    readonly button?: SectionHeaderButtonProps;
}

export interface SectionHeaderButtonProps {
    readonly label: string;
    onClick(): void;
}

interface State {}

export default class SectionHeader extends React.PureComponent<Props, State> {
    public state: State = {};

    public render(): React.ReactNode {
        const { name, bold = false, children, button } = this.props;
        return (
            <SectionHeaderStyle bold={bold}>
                <div className="titles">
                    <h4>{name}</h4>
                    {children && <div className="subtitle">{children}</div>}
                </div>
                {button && (
                    <ButtonVNext
                        onClick={button.onClick}
                        buttonType={"secondary"}
                        variant={"default"}
                        size={"md"}
                        label={button.label}
                    />
                )}
            </SectionHeaderStyle>
        );
    }
}
